import { setTheme } from "theme/default/setTheme";

export const setColor_9f3a38 = setTheme(({ theme }) => `color: ${theme.colors.color_9f3a38}`);
